<template>
  <div class="errPage-container">
    <div>
      <img
        src="@/assets/401_images/401.png"
        style="width: 559px; height: 296px"
        alt=""
        srcset=""
      />
      <div class="text">您已经登录超时，需要重新登录。</div>
      <div>
        <el-button
          icon="arrow-left"
          class="pan-back-btn"
          type="primary"
          @click="back"
        >
          确定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   methods: {
    back() {
      this.$router.replace('/login')
    },
  },
}
</script>

<style lang="scss" scoped>
.errPage-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  .text {
    height: 36px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #848d95;
    line-height: 36px;
    margin: 20px 0 30px;
  }
  .pan-back-btn {
    color: #fff;
    background: #538af7;
    width: 80px;
    height: 38px;
    padding: 0;
  }
}
</style>